import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Line, LineDTO } from '../../../../core/models/line.interface';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LineService } from '../../../../core/services/line/line';
import { HttpErrorResponse } from '@angular/common/http';
import { FormUtils } from '../../../../shared/utils';
import { LoadingService } from '../../../../core/services/loading/loading';

@Component({
  selector: 'app-line-form',
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatIconModule,
    FormsModule,
  ],
  templateUrl: './line-form.html',
  styleUrl: './line-form.scss',
})
export class LineForm {
  line: string | null = null;
  errorMsg: string[] | null = null;
  lineSelected: Line | null = null;
  private formBuilder = inject(FormBuilder);

  constructor(
    private dialogRef: MatDialogRef<LineForm>,
    private toastr: ToastrService,
    private serviceLine: LineService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit(): void {
    this.serviceLine.asyncErrorValidation$.subscribe((error) => {
      if (error) {
        this.errorMsg = FormUtils.parseErrorMsgs(error);
      }
    });

    this.serviceLine.selectedline$.subscribe((line) => {
      if (line) {
        this.line = String(line.id);
        this.lineSelected = line;
        this.lineForm.patchValue({
          ...line,
        });
      }
    });
  }

  lineForm = this.formBuilder.group({
    name: ['', [Validators.required, Validators.maxLength(256)]],
    description: ['', [Validators.required]],
  });

  closeDialog() {
    this.dialogRef.close();
  }

  saveLine() {
    const payload = this.lineForm.value as LineDTO;
    if (this.lineForm.status === 'VALID' && !this.line) {
      this.loadingService.show(true);
      this.serviceLine.createLine(payload).subscribe({
        next: (linea) => {
          this.loadingService.show(false);
          const msg = `La linea ${linea.name} fue CREADA correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    } else if (this.lineForm.status === 'VALID' && this.line) {
      this.loadingService.show(true);
      const id = Number(this.line);
      this.serviceLine.UpdateLine(id, { ...payload, id: id }).subscribe({
        next: (line) => {
          this.loadingService.show(false);
          const msg = `La linea ${line.name} fue EDITADA correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    }
  }
}
